/* REEF Black Friday sections. Loaded (deferred) by several sections; runs once. */
(function () {
  if (window.__reefBf) return;
  window.__reefBf = true;

  function init(root) {
    root = root || document;

    /* drag slider (REEF vs foam pad) */
    root.querySelectorAll('.rbf .ba:not([data-ready])').forEach(function (b) {
      b.setAttribute('data-ready', '');
      var r = b.querySelector('input');
      function set(v) { v = Math.max(0, Math.min(100, v)); b.style.setProperty('--p', v + '%'); r.value = Math.round(v); }
      function at(e) { var R = b.getBoundingClientRect(); set((e.clientX - R.left) / R.width * 100); }
      var drag = false, sx = 0, sy = 0, dec = false;
      b.addEventListener('pointerdown', function (e) { drag = true; dec = e.pointerType !== 'touch'; sx = e.clientX; sy = e.clientY; if (dec) { b.setPointerCapture(e.pointerId); at(e); } });
      b.addEventListener('pointermove', function (e) {
        if (!drag) return;
        if (!dec) { var dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy); if (dx < 8 && dy < 8) return; if (dy > dx) { drag = false; return; } dec = true; b.setPointerCapture(e.pointerId); }
        at(e);
      });
      function end(e) { if (drag && !dec && e.type === 'pointerup') at(e); drag = false; }
      b.addEventListener('pointerup', end); b.addEventListener('pointercancel', end);
      r.addEventListener('input', function () { set(+r.value); });
    });

    /* REEF vs foam: swipe dots (phones/tablets) */
    root.querySelectorAll('.rbf [data-rbf-vdots]:not([data-ready])').forEach(function (d) {
      d.setAttribute('data-ready', '');
      var q = d.parentNode.querySelector('.vq');
      if (!q || q.children.length < 2) return;
      var n = q.children.length, i0 = -1;
      d.innerHTML = Array.from({ length: n }, function (_, i) { return '<button type="button" aria-label="Question ' + (i + 1) + ' of ' + n + '"></button>'; }).join('');
      var bs = d.children;
      function upd() {
        var c = q.children, w = c[1].offsetLeft - c[0].offsetLeft, i = w ? Math.round(q.scrollLeft / w) : 0;
        if (q.scrollLeft + q.clientWidth >= q.scrollWidth - 4) i = n - 1;
        if (i === i0) return; i0 = i;
        for (var k = 0; k < n; k++) bs[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
      q.addEventListener('scroll', upd, { passive: true });
      d.addEventListener('click', function (e) { var i = [].indexOf.call(bs, e.target); if (i > -1) q.scrollTo({ left: q.children[i].offsetLeft - q.children[0].offsetLeft, behavior: 'smooth' }); });
      upd();
    });

    /* bundle mat picker */
    root.querySelectorAll('.rbf [data-rbf-bundles]:not([data-ready])').forEach(function (s) {
      s.setAttribute('data-ready', '');
      var chips = s.querySelector('.mats');
      function pick(id, focus) {
        s.querySelectorAll('.mat').forEach(function (c) { var on = c.getAttribute('data-m') === id; c.setAttribute('aria-checked', String(on)); c.tabIndex = on ? 0 : -1; if (on && focus) c.focus(); });
        s.querySelectorAll('.tier-panel').forEach(function (p) { p.hidden = p.getAttribute('data-m') !== id; });
        var c = s.querySelector('.mat[aria-checked=true]');
        if (c && window.innerWidth < 900) chips.scrollLeft = c.offsetLeft - (chips.clientWidth - c.offsetWidth) / 2;
      }
      chips.addEventListener('click', function (e) { var c = e.target.closest('.mat'); if (c) pick(c.getAttribute('data-m')); });
      chips.addEventListener('keydown', function (e) {
        var list = [].slice.call(s.querySelectorAll('.mat')), i = list.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); pick(list[(i + 1) % list.length].getAttribute('data-m'), true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); pick(list[(i - 1 + list.length) % list.length].getAttribute('data-m'), true); }
      });
      var m = (location.hash.match(/^#bundles-([\w-]+)$/) || [])[1];
      if (m && s.querySelector('.mat[data-m="' + m + '"]')) { pick(m); setTimeout(function () { s.scrollIntoView(); }, 60); }
    });

    /* sticky bar */
    root.querySelectorAll('.rbf-bar:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '');
      var hero = document.querySelector('.rbf-hero'), stop = document.querySelector('[data-rbf-bundles]');
      var past = !hero, at = false;
      function set() { var on = past && !at; bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', String(!on)); bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; }); }
      if (!('IntersectionObserver' in window)) { bar.classList.add('on'); return; }
      if (hero) new IntersectionObserver(function (es) { past = !es[0].isIntersecting; set(); }, { threshold: 0 }).observe(hero);
      if (stop) new IntersectionObserver(function (es) { at = es[0].isIntersecting; set(); }, { threshold: 0.1 }).observe(stop);
      set();
    });
  }

  /* add to cart (event delegation, so it works after theme-editor re-renders) */
  function done(b, ok, msg) {
    b.classList.toggle('ok', ok);
    b.textContent = ok ? 'Added ✓' : 'Try again';
    var live = b.closest('.rbf').querySelector('[data-rbf-msg]');
    if (live) live.textContent = msg;
    setTimeout(function () { b.disabled = false; b.classList.remove('ok'); b.textContent = b.getAttribute('data-label'); }, 2200);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.rbf [data-rbf-add]');
    if (!b || b.disabled) return;
    var v = b.getAttribute('data-rbf-add');
    if (!v) return;
    b.disabled = true; b.textContent = 'Adding…';
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +v, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        done(b, true, 'Added to cart.');
        try {
          if (window.upcartRefreshCart) { window.upcartRefreshCart(); window.upcartOpenCart && window.upcartOpenCart(); }
          else { document.dispatchEvent(new CustomEvent('cart:build')); document.dispatchEvent(new CustomEvent('cart:open')); }
        } catch (x) {}
      })
      .catch(function () { done(b, false, 'Could not add that to your cart. It may be sold out.'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
